module.exports = __webpack_public_path__ + "static/media/Purple_Exp_Bar@3x.5cb56088.png";